<template>
  <div>
    <list
      ref="list"
      unit="访客"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      @reset-query="$emit('reset-select')"
      :get-data-func="getDataFunc"
      :show-summary="summaryShow"
      :summary-method="summaryFunc"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="仓库名称">
          <el-select v-model="params.WarehouseId" placeholder="请选择" clearable>
            <el-option
              v-for="item in wareList"
              :key="item.WarehouseId"
              :label="item.WarehouseName"
              :value="item.WarehouseId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input clearable v-model="params.GoodsName" placeholder="请输入商品名称" />
        </el-form-item>
        <el-form-item label="现存量状态">
          <el-select v-model="params.ExistStatus" placeholder="请选择" clearable>
            <el-option label="大于0" :value="0"></el-option>
            <el-option label="等于0" :value="1"></el-option>
            <el-option label="小于0" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="存货分类">
          <tree-select ref="treeSelect" :props="props" :options="categoryList" v-model="params.IdChain" clearable
            :label="params.BigClassName" accordion parent-select placeholder="请选择分类" @node-select="onTreeSelect($event)" />
        </el-form-item>

        <!-- <el-form-item label="展示模式">
          <el-select  v-model="showType" placeholder="请选择" @change="resetList">
            <el-option label="按库存状态" :value="0"></el-option>
            <el-option label="按库存分布" :value="1"></el-option>
            <el-option label="库存批次账" :value="2"></el-option>
          </el-select>
        </el-form-item>-->
      </template>
      <template slot="table" v-if="showList==0">
        <el-table-column label="序号" type="index" width="60" align="center" />
        <el-table-column prop="WarehouseName" label="仓库名称" />
        <el-table-column prop="GoodsCode" sortable label="商品编码" />
        <el-table-column prop="GoodsName" sortable label="商品名称" />
        <el-table-column prop="Model" label="规格型号" />
        <el-table-column prop="MainUnitName" label="主计量单位" />
        <el-table-column prop="ExistQuantity" sortable label="现存量" />
        <el-table-column prop="BigClassName" sortable label="存货分类" />
        <!--<el-table-column prop="AvailableQuantity" label="可用量" />-->
        <!--<el-table-column prop="ExistAmount" label="结存金额" />-->
      </template>
      <template slot="table" v-if="showList==1">
        <el-table-column label="序号" type="index" width="60" align="center" />
        <el-table-column prop="GoodsCode" label="商品编码" align="center" />
        <el-table-column prop="GoodsName" label="商品名称" align="center" />
        <el-table-column prop="Model" label="规格型号" align="center" />
        <el-table-column prop="MainUnitName" label="主计量单位" align="center" />
        <el-table-column
          :label="item.WarehouseName"
          align="center"
          v-for="(item,index) in cList[0]"
          :key="index"
        >
          <el-table-column label="现存量（主）" align="center">
            <template slot-scope="{$index}">
              <span>{{cList[index][$index].ExistQuantity}}</span>
            </template>
          </el-table-column>
          <!--<el-table-column label="结存金额" align="center">
            <template slot-scope="{$index}">
              <span>{{cList[index][$index].ExistAmount}}</span>
            </template>
          </el-table-column>-->
        </el-table-column>
        <!-- <el-table-column label="总仓" align="center">
          <el-table-column prop="ExistQuantity" label="现存量（主）" align="center" />
          <el-table-column prop="ExistAmount" label="结存金额" align="center" />
        </el-table-column>
        <el-table-column label="小计" align="center">
          <el-table-column prop="ExistQuantity" label="现存量（主）" align="center" />
          <el-table-column prop="ExistAmount" label="结存金额" align="center" />
        </el-table-column>-->
      </template>
      <template slot="table" v-if="showList==2">
        <el-table-column label="序号" type="index" width="60" align="center" />
        <el-table-column prop="WarehouseName" label="仓库名称" />
        <el-table-column prop="GoodsCode" label="商品编码" />
        <el-table-column prop="GoodsName" label="商品名称" />
        <el-table-column prop="Model" label="规格型号" />
        <el-table-column prop="MainUnitName" label="主计量单位" />
        <el-table-column prop="Model" label="批号" />
        <!-- <el-table-column label="失效日期" /> -->
        <el-table-column prop="ExistQuantity" label="现存量（主）" />
        <el-table-column prop="UnitName" label="现存量（包装）" />
        <!--<el-table-column prop="ExistAmount" label="结存金额" />-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import treeSelect from "@/components/common/treeSelect";

export default {
  mixins: [listMixin],
  components: { list,treeSelect },
  data() {
    return {
      cList: [],
      // api: require("@/api/stock/stBook").default.getStatusStat,
      api:require("@/api/stock/stBook").default,
      wareApi: require("@/api/ba/warehouse").default,
      bigClassApi: require("@/api/ba/class").default,
      showType: 0,
      showList: 0,
      wareList: [],
      BigClassList:[],
      params: {
        ExistStatus: "",
        WarehouseId: null,
        GoodsName: "",
        IdChain:null,
        BigClassName:''
      },
      summaryShow: false,
      total: null,
      categoryList:[],
      props: {
        value: "IdChain",
        label: "ClassName",
        children: "children",
      },
    };
  },
  mounted() {
    this.wareApi.list({ PageIndex: 1, PageSize: 100 }).then((res) => {
      this.wareList = res.Data;
      sessionStorage.setItem("ware", JSON.stringify(res.Data));
    });

    this.bigClassApi.list({ ClassType: 6 }).then((res) => {
      this.categoryList = this.$commonJs.toTreeData(res.Data, "ClassId");
    });
  },
  methods: {
    onTreeSelect(t) {
      if(!t){
        this.params.IdChain = null
      }else{
        this.params.IdChain = t.IdChain;
      }
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(this.params).then(() => {
        loading.close();
      });
    },
    resetList(e) {
      switch (e) {
        case 0:
          this.api = require("@/api/stock/stBook").default.getStatusStat;
          this.$nextTick(() => {
            this.$refs.list.query();
          });
          break;
        case 1:
          this.api = require("@/api/stock/stBook").default.getWarehouseStat;
          this.$nextTick(() => {
            this.$refs.list.query().then((res) => {
              this.cList = [];
              res.list.forEach((item) => {
                this.cList.push(item.Warehouses);
              });
            });
          });
          break;
        case 2:
          this.api = require("@/api/stock/stBook").default.getBatchStat;
          this.$nextTick(() => {
            this.$refs.list.query().then((res) => {});
          });
          break;
      }
      this.showList = null;
      setTimeout(() => {
        this.showList = e;
      }, 20);
    },
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.getStatusStat(params).then(res => {
          let times = Math.ceil(res.Count / params.pageSize);
          //判断是否最后一页
          if (times == params.pageIndex) {
            this.api.getStatusStatTotal(params).then(res => {
              if (res.Code == 0 && res.Data) {
                this.total = res.Data[0];
                this.summaryShow = true;
              } else {
                this.summaryShow = false;
              }
            })
          } else {
            this.summaryShow = false;
          }
          resolve(res);
        })
      })
    },
    summaryFunc(param) {
      const { columns, data } = param;
      var fields = ['ExistQuantity']; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        var field = fields.find(x => x == column.property);
        if (field) {
          console.log(field, index);
          sums[index] = "";
          if (this.total) {
            sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
  },
};
</script>